'use strict';

var React = require('react'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    AlertActionCreators = require('../actions/AlertActionCreators'),
    AlertTypes = require('../constants/AlertTypes'),
    ImageUploader = require('../utils/ImageUploader'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    createTokenSource = require('cancellation'),
    { each } = require('underscore'),
    { PropTypes } = React;

require('./ImagePicker.less');

var IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/tiff'],
    CANCEL_REASON = {};

var ImagePicker = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    imageUrl: PropTypes.string,
    size: PropTypes.oneOf(['avatar', 'thumbnail', 'cover']),
    onUploadSuccess: PropTypes.func.isRequired,
    onUploadStart: PropTypes.func,
    onUploadProgress: PropTypes.func,
    onUploadError: PropTypes.func,
    accept: PropTypes.arrayOf(PropTypes.string),
    multiple: PropTypes.bool,
    hideProgress: PropTypes.bool,
    cancelOnChange: PropTypes.bool
  },

  getDefaultProps() {
    return {
      accept: IMAGE_TYPES
    };
  },

  getInitialState() {
    return {
      isUploading: false,
      progress: 0
    };
  },

  getCSSModifiers() {
    return [this.props.size];
  },

  componentDidMount() {
    this.tokenSource = createTokenSource();
    this.imageUploader = ImageUploader.createFileUploader();
  },

  componentWillUnmount() {
    this.cancelUploadsIfNeeded();
  },

  getStyle() {
    var imageUrl = this.props.imageUrl;
    if (imageUrl) {
      return {
        backgroundImage: 'url(' + imageUrl + ')'
      };
    }
  },

  render() {
    return (
      <div className={this.getClassName()}
           style={this.getStyle()}>

        <input className='ImagePicker-input'
               type='file'
               value=''
               accept={this.props.accept}
               multiple={this.props.multiple}
               onChange={this.handleFileUpload} />

        {!this.props.hideProgress &&
          <div className='ImagePicker-progress'
               data-uploading={this.state.isUploading}
               style={{ width: Math.floor(this.state.progress * 100) + '%' }} />
        }

        <div className='ImagePicker-placeholder'>
          {this.props.children}
        </div>
      </div>
    );
  },

  handleFileUpload(e) {
    this.cancelUploadsIfNeeded();
    each(e.target.files, this.uploadImage);
  },

  cancelUploadsIfNeeded() {
    if (!this.props.cancelOnChange) {
      return;
    }

    if (this.tokenSource) {
      this.tokenSource.cancel(CANCEL_REASON);
    }

    this.tokenSource = createTokenSource();
  },

  uploadImage(filePath) {
    if (this.props.onUploadStart) {
      this.props.onUploadStart(filePath);
    }

    var handleProgress = (progress) => {
      if (this.props.onUploadProgress) {
        this.props.onUploadProgress(filePath, progress);
      }

      if (this.isMounted()) {
        this.setState({
          progress: progress,
          isUploading: true
        });
      }
    };

    this.imageUploader
      .uploadFile(filePath, handleProgress, this.tokenSource.token)
      .then(image => {
        this.props.onUploadSuccess(filePath, image);
      })
      .catch(err => {
        if (err === CANCEL_REASON) {
          return;
        }

        AlertActionCreators.showAlert(AlertTypes.UPLOAD_USER_IMAGE_ERROR);

        if (this.props.onUploadError) {
          this.props.onUploadError(filePath);
        }
      })
      .finally(() => {
        if (this.isMounted()) {
          this.setState({
            progress: 0,
            isUploading: false
          });
        }
      });
  }
});

module.exports = ImagePicker;



/** WEBPACK FOOTER **
 ** ./organisms/ImagePicker.jsx
 **/